import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import useHelpers from "@hooks/useHelpers";
import { useCallback, useEffect } from "react";
import useQueryString from "@hooks/useQueryString";
import AuthScreen from "@/_MiniApps/auth/ui/AuthScreen/AuthScreen";
import banners from "@data/banners/login-pages/signup.json";
import { useCMS } from "@hooks/useCMS";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import stl from "./UserSignUp.module.css";
import { handleHasAccountEvent } from "@/utils/common";
var UserSignUp = function UserSignUp() {
  var _queryString$returnTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var lang = useLang();
  var queryString = useQueryString();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var result = queryString.returnTo + (queryString !== null && queryString !== void 0 && (_queryString$returnTo = queryString.returnTo) !== null && _queryString$returnTo !== void 0 && _queryString$returnTo.includes('?') ? '&' : '?') + Object.entries(queryString).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      k = _ref2[0];
    return k !== 'returnTo';
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      k = _ref4[0],
      v = _ref4[1];
    return "".concat(k, "=").concat(v);
  }).join('&');
  var returnUrl = (queryString.returnTo ? result : null) || "/user/account?ref=authSuccess";
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user,
    hasAccount = _useSession.hasAccount;
  var onSuccess = useCallback(function () {
    if (null === hasAccount || !user) return;
    handleHasAccountEvent({
      hasAccount: hasAccount,
      status: "Success",
      phone_number: user === null || user === void 0 ? void 0 : user.phone_number,
      lang: lang,
      referral_location: queryString.referralLocation
    });
    navigateToHard(returnUrl);
  }, [hasAccount, user]);
  useEffect(function () {
    if (isLoggedIn) {
      onSuccess();
    }
  }, [isLoggedIn]);
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("sign_register"),
    description: t("sign_register_access_account")
  };
  var external_links = {
    privacyPolicyLinkProps: {
      onClick: function onClick() {
        return navigateTo("/privacy-policy");
      }
    },
    termsLinkProps: {
      onClick: function onClick() {
        return navigateTo("/terms");
      }
    }
  };
  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    hideOrangeHeadBtn: true,
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement(AuthScreen, {
    external_links: external_links,
    design: authScreenDesign,
    onSuccess: onSuccess,
    customClass: stl.customClass,
    isSmallPopup: false
  }));
};
export default UserSignUp;